import * as React from "react";

import { DesignToken, Text } from "@livechat/design-system-react-components";

import { IRecurlyCoupon } from "store/entities/recurly";
import { RecurlyCouponDuration } from "store/entities/recurly/interfaces";
import { withVar } from "themes/helpers";
import { plural } from "utils/string";

interface IProps {
  daysLeft: number;
  nonViewersCount: number;
  coupon: IRecurlyCoupon | null;
}

export const PhaseTrialNoCC: React.FC<IProps> = ({ daysLeft, nonViewersCount, coupon }) => {
  const trialEnding = daysLeft <= 7;

  return (
    <>
      <Text customColor={withVar(trialEnding ? DesignToken.ActionNegativeDefault : DesignToken.ActionPositiveDefault)}>
        Your trial is up and running! You have{" "}
        <strong>
          {daysLeft} {plural(daysLeft, "day", "days")} left{" "}
        </strong>
        to test HelpDesk.
      </Text>
      {coupon && coupon.duration === RecurlyCouponDuration.SingleUse && (
        <Text>
          The “<strong>{coupon.code}</strong>” coupon will be applied for your first payment.
        </Text>
      )}
      <Text>
        You have{" "}
        <strong>
          {nonViewersCount} paid {plural(nonViewersCount, "user", "users")}
        </strong>{" "}
        in HelpDesk.
      </Text>
    </>
  );
};
